import { render, staticRenderFns } from "./ExcelDownload.vue?vue&type=template&id=0fd473b0&scoped=true&"
import script from "./ExcelDownload.vue?vue&type=script&lang=js&"
export * from "./ExcelDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd473b0",
  null
  
)

export default component.exports